module.exports = __webpack_public_path__ + "img/06_C_T.7f5a93cd.png";